import { ContentChangedEvent, GenericContentEditFeature, Keys } from 'roosterjs-editor-types';
import { safeInstanceOf } from 'roosterjs-editor-dom';

const STYLE_LIST = ['lower-alpha', 'lower-roman', 'decimal'];

export const SmartOrderedListFeature: GenericContentEditFeature<ContentChangedEvent> = {
    keys: [Keys.CONTENTCHANGED], // Triggered by ContentChangedEvent
    shouldHandleEvent: event => safeInstanceOf(event.data, 'HTMLOListElement'),
    handleEvent: (event, editor) => {
        const ol = event.data as HTMLOListElement;
        const parentOl = editor.getElementAtCursor('OL', ol.parentNode);
        if (safeInstanceOf(parentOl, 'HTMLOListElement')) {
            ol.style.listStyle =
                STYLE_LIST[
                    (STYLE_LIST.indexOf(parentOl.style.listStyleType) + 1) % STYLE_LIST.length
                ];
        }
    },
};
